import styled from 'styled-components';

import { COLORS } from '@xing-com/crate-lebenslauf-constants';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

const Container = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
`;

export const CreativeBackground: React.FC = () => {
  const { theme } = useReadVitaReactiveVariable();
  const { primary, secondary } = COLORS[theme?.color || 'DARK_BLUE'];
  return (
    <Container>
      <svg
        width="595"
        height="222"
        viewBox="0 0 595 222"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M-5 -42H595L607.5 222L-5 84V-42Z" fill={primary} />
        <path
          d="M-5 -21.5L397 -71L274.329 195L-5 131V-21.5Z"
          fill={secondary}
        />
      </svg>
    </Container>
  );
};
